import { useCallback } from "react";
import { unreadMessagesCountFamily } from "../../session/state";
import { setFaviconAndTitleBasedOnUnreadMessagesCount } from "../chat/utils";
import { activeConversationSidAtom } from "../state";
import { useAtomCallback } from "jotai/utils";
import { DEFAULT_APP_TITLE } from "../../config";
import { DEFAULT_WAITING_ROOM_PAGE_TITLE } from "./metadata";

export const PROVIDER_NO_SHOW_TITLE = `👋 Provider not here? - ${DEFAULT_APP_TITLE}`;

export function useClearProviderNoShowTabTitleCallback() {
  const getActiveConversationSid = useAtomCallback(
    useCallback((get) => get(activeConversationSidAtom), []),
  );
  const getUnreadMessagesCount = useAtomCallback(
    useCallback(
      (get, _set, activeConversationSid?: string) =>
        get(unreadMessagesCountFamily(activeConversationSid ?? "")),
      [],
    ),
  );

  return useCallback(
    function clearProviderNoShowTabTitle() {
      if (document.title !== PROVIDER_NO_SHOW_TITLE) {
        return;
      }

      const activeConversationSid = getActiveConversationSid();
      const unreadMessagesCount = getUnreadMessagesCount(activeConversationSid);
      setFaviconAndTitleBasedOnUnreadMessagesCount(
        unreadMessagesCount,
        DEFAULT_WAITING_ROOM_PAGE_TITLE,
      );
    },
    [getActiveConversationSid, getUnreadMessagesCount],
  );
}
